module.exports = __webpack_public_path__ + "img/emoji_106.b2ec5022.png";